<template>
  <div class="flex flex-col w-full">
    <div class="flex flex-wrap">
      <div class="w-full px-3 mb-3">
        <label class="block w-full">
          {{ $t('modals.contract.contractType') }}
        </label>
        <label class="inline-flex items-center">
          <input
            v-model="contract.isTrial"
            type="checkbox"
            class="w-4 h-4 form-checkbox"
            :value="contract.isTrial"
          >
          <span class="ml-2 text-base normal-case">{{ $t('modals.contract.isTrial') }}</span>
        </label>
      </div>
      <div class="w-1/2 px-3 mb-3">
        <input-select-validated
          ref="contract.priceListName"
          v-model="contract.priceListName"
          :label="$t('modals.contract.priceList')"
          rules="required"
          :options="priceLists"
        />
      </div>
      <div class="w-1/2 px-3 mb-3">
        <input-date-validated
          ref="contract.startDate"
          v-model="contract.startDate"
          :label="$t('modals.contract.startDate')"
          rules="required"
        />
      </div>
      <div class="w-full px-3 mb-3">
        <input-text-validated
          ref="contract.note"
          v-model="contract.note"
          input-class="w-full"
          :label="$t('modals.contract.note')"
        />
      </div>
    </div>
    <div class="w-1/2 px-3 mb-3">
      <input-select-validated
        ref="contract.type"
        v-model="contract.type"
        :label="$t('modals.contract.productType')"
        rules="required"
        :options="productTypeOptions"
      />
    </div>
    <product-form
      v-if="contract.type === 'EXPERT'"
      :data="contract"
      :product="expertProduct"
      :setup-product="setupExpertProduct"
    />
    <product-form
      v-else
      :data="contract"
      :product="basicProduct"
      :setup-product="setupBasicProduct"
    />
  </div>
</template>

<script>
import InputDateValidated from '@/components/form/date-validated'
import InputSelectValidated from '@/components/form/select-validated'
import InputTextValidated from '@/components/form/text-validated'
import { getDiscounts, getDiscountsSetup, getPricelists } from '@/config'
import ProductForm from '@/components/modals/product/product-form'

export default {
  components: {
    InputDateValidated,
    InputSelectValidated,
    InputTextValidated,
    ProductForm
  },
  props: {
    contract: { type: Object, default: () => ({}) },
    expertProduct: { type: Object, required: true },
    setupExpertProduct: { type: Object, required: true },
    basicProduct: { type: Object, required: true },
    setupBasicProduct: { type: Object, required: true }
  },
  computed: {
    productTypeOptions () {
      // eslint-disable-next-line no-void
      void this.$i18n.locale
      return [
        { value: 'EXPERT', name: this.$t('modals.contract.expertPackage') },
        { value: 'BASIC', name: this.$t('modals.contract.basicPackage') }
      ]
    },
    priceLists () {
      // eslint-disable-next-line no-void
      void this.$i18n.locale
      return getPricelists()
    }
  },
  created () {
    this.discounts = getDiscounts()
    this.discountsSetup = getDiscountsSetup()
  }
}
</script>
